module.exports = __webpack_public_path__ + "img/36_38.82be9d96.png";